import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class UserLoginCountryBypassService extends Service {
	constructor(injector: Injector) {
		super("UserLoginCountryBypass", injector);
	}

	// API
	getByUserId(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/GetByUserId/${id}`);
	}
}